<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Create Sample Order</h2>
        <sample-order-form-component @orderAction="createSampleOrder"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import SampleOrderFormComponent from "@/components/orders/sample-order-form-component";
import PageHeader from "@/components/page-header";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  components: {SampleOrderFormComponent, Layout, PageHeader},
  page: {
    title: "Create Sample Order",
    meta: [{ name: "description", content: appConfig.description }]
  },
  name: "create-sample-order",
  data() {
    return {
      title: "Create Sample Order",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Create Sample Order",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addSampleOrder: 'orders/addNewSampleOrder'
    }),
    async createSampleOrder(data){
      await this.addSampleOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Sample Order added successfully`)
          this.$router.push(routeItems.customize_sample_order_route+'/'+resp.publicId)
        }

      })
    }
  }
}
</script>

<style scoped>

</style>
